import {Component, OnInit, Output, EventEmitter} from '@angular/core';
import {Subscription} from "rxjs/Subscription";
import {LayoutService} from "../layout.service";
import {appVersion} from "../../../../environments/environment";
import {fromEvent} from 'rxjs';
import { BsModalRef, BsModalService } from 'ngx-bootstrap';
import { ModalVentasComponent } from '../../../+tickets/folder/modal-ventas/modal-ventas.component';
import { UsersActionsComponent } from '../../../+admin/+users/+actions/users-actions.component';
import { AuthService } from 'app/+login/auth.service';
import { HasPermissionService } from 'app/shared/haspermission/hasPermission.service';

@Component({
  selector: "sa-navigation",
  templateUrl: "./navigation.component.html",
  styleUrls: ["left-panel.css"],
  providers: [BsModalService],
})
export class NavigationComponent implements OnInit {
  isMinified = false;
  currentX = null;
  listAside = [false, false, false, false];
  listAside2 = [false, false, false, false];
  inside = false;
  outside = true;
  blocked: boolean;
  mouseMove = fromEvent(document, "mousemove");
  public bsModalNewAddress: BsModalRef;
  // Usamos el decorador Output
  @Output() lockedMenu = new EventEmitter();
  public nameLogget: string;
  dashboarOT: boolean = false;
  operaciones: boolean = false;
  dashboarAdminIngresos: boolean = false;
  verPanelRecuperadores: boolean = false;
  mtto: boolean = false;

  constructor(
    private layout: LayoutService,
    private bsModalService: BsModalService,
    private authorization: AuthService,
    private hasPermission:HasPermissionService,
  ) {}

  public subscribe: Subscription;
  public appVersion = appVersion;

  ngOnInit() {
    this.isMinified = this.layout.store.menuMinified;
    if (this.layout.store.menuMinified == true) {
      jQuery("#icono-minified").removeClass("hidden");
      jQuery("#left-panel-logo").addClass("hidden");
      // jQuery('#left-panel-lu').css('margin-top', '0px');
      jQuery(".left-menu-element").css("padding-left", "25px");
      jQuery(".icono").css("color", "white");
      jQuery("#minifyButton").css("right", "-30px");
      jQuery("#minifyIcon").css("margin-right", "0px");
    } else {
      jQuery("#minifyButton").css("right", "-15px");
      jQuery("#minifyIcon").css("margin-right", "4px");
    }

    this.subscribe = this.layout.subscribe((success) => {
      this.isMinified = success.menuMinified;
      if (success.menuMinified == true) {
        jQuery("#icono-minified").removeClass("hidden");
        jQuery("#left-panel-logo").addClass("hidden");
        // jQuery('#left-panel-lu').css('margin-top', '0px');
        jQuery(".left-menu-element").css("padding-left", "25px");
        jQuery(".icono").css("color", "white");
        jQuery("#minifyButton").css("right", "-30px");
        jQuery("#minifyIcon").css("margin-right", "0px");
      } else {
        jQuery("#icono-minified").addClass("hidden");
        jQuery("#left-panel-logo").removeClass("hidden");
        // jQuery('#left-panel-lu').css('margin-top', '0');
        jQuery(".left-menu-element").css("padding-left", "25px");
        jQuery(".icono").css("color", "#51bb83");
        jQuery("#minifyButton").css("right", "-15px");
        jQuery("#minifyIcon").css("margin-right", "4px");
      }
    });
    // parece ser que se reinicia el compoente cuando redirecciono a alguna opcion del menu
    this.getStatus();
    if (this.blocked) {
      this.lockedMenu.emit({ lockedMenu: this.blocked });
      if (this.isMinified) {
        this.toggle();
      }
    }

    this.mouseMove.subscribe({
      next: (position: any) => {
        if (
          position.pageX <= 100 &&
          !this.inside &&
          !this.blocked &&
          this.currentX != position.pageX
        ) {
          this.currentX = position.pageX;
          this.getStatus();
          this.inside = true;
          this.outside = false;
          if (this.isMinified) {
            this.toggle();
          }
        }
        if (
          position.pageX > 212 &&
          !this.outside &&
          !this.blocked &&
          this.currentX != position.pageX
        ) {
          this.currentX = position.pageX;
          this.getStatus();
          this.outside = true;
          this.inside = false;
          if (!this.isMinified && !this.blocked) {
            this.toggle();
          }
        }
      },
    });
    if (this.blocked) {
      $(".megacableIcon").css("margin-left", "216px");
    } else {
      $(".megacableIcon").css("margin-left", "115px");
    }
    
    this.nameLogget = this.authorization.token.name;
    const user = JSON.parse(localStorage.getItem("info_user_logged"));
    const profile = user.userAppView.profileName
    const profileOp = ['Atencion domiciliaria Radio Juniors',
      'Atencion domiciliaria Radio Migraciones',
      'Atencion domiciliaria Radio Operador',
      'Atencion Domiciliaria Radio Quejas',
      'Atencion Domiciliaria RO sin asignacion',
      'Administrador de sistema'
    ]
    if((profile == 'Atencion domiciliaria Supervisor Radio' || profile == 'Administrador de sistema') && this.hasPermission.canAccess('DASHBOARD.OT')){
      this.dashboarOT = true;

    }
    if(profile && profileOp.includes(profile.trim()) && this.hasPermission.canAccess('DASHBOARD.COMPLETE.OPERATIONS')){
      this.operaciones = true;

    }

    const profileMtto = [
      'Administrador Mantenimiento',
      'Administrador Mantenimiento Wifi',
      'Jefe Mantenimiento',
      'Radio Operador MYC (N1)',
      'Supervisor De Radio Operador MYC (N1)',
      'Supervisor Mantenimiento',
      'Supervisor mesa de analisis',
      'Administrador de sistema'
    ]

    if(profile && profileMtto.includes(profile.trim())){
      this.mtto = true;
    }

    const profileAdminIngresos = [
      'Administrador De Ingresos',
      'Administrador de sistema'
    ];
    if((profile && profileAdminIngresos.includes(profile.trim())) && this.hasPermission.canAccess('view.sale.admin')){
      this.dashboarAdminIngresos = true;
    }

    const profileRecuperadores = [
      'Radio Operador Recuperador Equipos',
      'Administrador de sistema',
      'Administrador Recuperadores Equipos'
    ];
    if((profile && profileRecuperadores.includes(profile.trim())) && this.hasPermission.canAccess('panel.recuperadores')){
      this.verPanelRecuperadores = true;
    }

  }

  setStatus(inside, outside, blocked) {
    let statusMenu = {
      inside: inside,
      outside: outside,
      blocked: blocked,
    };
    localStorage.setItem("statusMenu", JSON.stringify(statusMenu));
  }

  getStatus() {
    let status = JSON.parse(localStorage.getItem("statusMenu"));
    if (status) {
      this.inside = status.inside;
      this.outside = status.outside;
      this.blocked = status.blocked;
    }
  }

  toggleLock() {
    this.blocked = !this.blocked;
    if (this.blocked) {
      $(".megacableIcon").css("margin-left", "216px");
    } else {
      $(".megacableIcon").css("margin-left", "115px");
    }
    this.setStatus(this.inside, this.outside, this.blocked);
    this.lockedMenu.emit({ lockedMenu: this.blocked });
  }

  toggle() {
    this.layout.onMinifyMenu();
  }
  openSearchAddress(): void {
    this.bsModalNewAddress = this.bsModalService.show(ModalVentasComponent, {
      backdrop: "static",
      initialState: {
        validacion: "navigation",
      },
    });
  }

  ngOnDestroy() {
    if (this.bsModalNewAddress) {
      this.bsModalNewAddress.hide();
    }
  }

  hasExtraConfigCuadAgendex(): boolean {
    const user = JSON.parse(localStorage.getItem("info_user_logged"));
    if (user) {
      const ex = user.userAppView;
      const extraConfiguration = ex.extraConfiguration;
      if (extraConfiguration && extraConfiguration.externa) {
        return extraConfiguration.externa;
      }
    }
    return false;
  }

  hasExtraVTWConfig(): boolean {
    const user = JSON.parse(localStorage.getItem('info_user_logged'));
    if (user) {
      const ex = user.userAppView;
      const extraConfiguration = ex.extraConfiguration;
      if (extraConfiguration && extraConfiguration.vtw) {
        return extraConfiguration.vtw;
      }
    }
    return false;
  }

  isUserAdmin(): boolean {
    const user = JSON.parse(localStorage.getItem('info_user_logged'));
    if (user.userAppView.profileId != 1) {
      if (!user.userAppView.profileName.includes('Administrador')) {
        return false;
      }
      return true;
    }
    return true;
  }
}
